var _defs, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogov1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 245.47 245.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#00a4ff;}.cls-3{fill:#002bff;}.cls-4{fill:#ffa91f;}.cls-5{fill:#ff002b;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 122.73,
    cy: 122.73,
    r: 122.73
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M210.73,79.7S179.33,86,173,79.7c-4.93-4.91,0-27.79,0-27.79h37.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M60,168.41C39.31,147.83,60,52,60,52H34.73V193.56h85V168.41S70.54,178.94,60,168.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M130.37,77.11c20.66,20.59,0,116.45,0,116.45H155.6V52H73.25V77.11S120.27,67.06,130.37,77.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M210.61,132.69s-30.77,5.61-37.74,0c-5.42-4.37-4.93-22.88,0-27.79,6.34-6.31,37.74,0,37.74,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M210.61,193.56H172.87s-4.93-22.88,0-27.79c6.34-6.32,37.74,0,37.74,0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogov1);
export default __webpack_public_path__ + "static/media/logov1.beabf23ac3149921d9e7d80d3e6b5072.svg";
export { ForwardRef as ReactComponent };